import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardHeader from '../dashboard_header';
import SideMenu from '../dashboard_menu';
import DashboardFooter from '../dashboard_footer';

const DashboardErrorPage: React.FC<{ message?: string }> = ({ message }) => {
  const navigate = useNavigate();
  return (
    <>
      <DashboardHeader />
      <SideMenu />
      <div className={"vertical-overlay"} />
      <div className={"main-content"}>
        <div className={"page-content"}>
          <div className="container-fluid">
            <div className="flex flex-col items-center justify-center min-h-[60vh] py-12">
              <div className="bg-white rounded-3xl shadow-2xl p-10 flex flex-col items-center w-full max-w-lg">
                {/* SVG Graphic */}
                <svg className="w-28 h-28 mb-6" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="30" y="60" width="140" height="80" rx="20" fill="#fef3c7"/>
                  <rect x="60" y="90" width="80" height="20" rx="10" fill="#fbbf24"/>
                  <circle cx="70" cy="80" r="8" fill="#f59e42"/>
                  <circle cx="130" cy="80" r="8" fill="#f59e42"/>
                  <path d="M80 120 Q100 140 120 120" stroke="#f59e42" strokeWidth="6" strokeLinecap="round" fill="none"/>
                </svg>
                <h2 className="text-2xl font-extrabold text-yellow-600 mb-2">Dashboard Error</h2>
                <p className="text-gray-700 mb-4 text-center">{message || 'Something went wrong in the dashboard. Please try again or return to the dashboard home.'}</p>
                <button
                  onClick={() => navigate('/institutions/home')}
                  className="mt-2 px-6 py-3 bg-gradient-to-r from-yellow-400 to-orange-400 text-white rounded-xl shadow-lg hover:from-orange-400 hover:to-yellow-400 transition-all font-semibold"
                >
                  Go to Dashboard Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DashboardFooter />
    </>
  );
};

export default DashboardErrorPage; 